/**
 * @fileoverview Certification checkboxes, section title, and installed-capacity field.
 */

import styles from "./Certifications.module.css";
import CertificationCheckboxRows from "./CertificationCheckboxRows";

const CertificationsCheckboxes = ({ section, company, isTablet }) => {
  const {
    t,
    certifications,
    selectedCertifications,
    handleCheckboxChange,
    getFieldValidationState,
    getErrorMessage,
    handleInputChange,
    handleFieldChange,
  } = section;

  return (
    <>
      <div className={styles.sectionHeader}>
        <span className={styles.sectionTitle}>
          {t("components.certifications.title")}
        </span>
        <div className={styles.sectionDivider}></div>
      </div>
      <div className={styles.checkboxContainer}>
        <CertificationCheckboxRows
          certifications={certifications}
          selectedCertifications={selectedCertifications}
          onCheckboxChange={handleCheckboxChange}
          t={t}
        />
      </div>
      <div
        className={`${styles.inputRow} ${
          isTablet ? styles.tabletInputRow : ""
        }`}
      >
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            {t("components.certifications.capacityAndTechnologiesLabel")}
          </label>
          <textarea
            className={`${styles.capacityAndTechnologiesInput} ${
              getFieldValidationState(
                "capacidadInstalada",
                company?.capacidadInstalada || "",
              ) === "error"
                ? styles.inputError
                : ""
            }`}
            placeholder={t(
              "components.certifications.capacityAndTechnologiesPlaceholder",
            )}
            value={company?.capacidadInstalada || ""}
            onChange={(e) => {
              const value = e.target.value;
              company.capacidadInstalada = value;
              handleInputChange("capacidadInstalada", value);
              handleFieldChange("capacidadInstalada", value);
            }}
            maxLength={300}
          />
          {getErrorMessage("capacidadInstalada") && (
            <p className={styles.errorMessage}>
              {getErrorMessage("capacidadInstalada")}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default CertificationsCheckboxes;
